module.exports = __webpack_public_path__ + "img/ic-arrow-right-solid-black.8a824c61.svg";